import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import { API } from "@/lib/api";

const ERROR_KEYS = {
  not_allowed: "login.errorNotAllowed",
  disabled: "login.errorDisabled",
  email_unverified: "login.errorEmailUnverified",
  auth_failed: "login.authFailed",
};

export default function Login() {
  const { t } = useTranslation();
  const errorCode = new URLSearchParams(window.location.search).get("error");
  const error = errorCode ? t(ERROR_KEYS[errorCode] || "login.authFailed") : null;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // The backend builds Google's consent URL (deriving the redirect_uri from forwarded headers)
    // and 302-redirects the browser to Google.
    window.location.href = `${API}/auth/google/login`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-6">
      <div className="w-full max-w-xs animate-fade-up">
        <div className="flex justify-center mb-8">
          <div className="h-12 w-12 border border-white/15 flex items-center justify-center">
            <Lock className="h-5 w-5 text-white/70" strokeWidth={1.75} />
          </div>
        </div>

        <h1 className="text-center font-display font-bold text-xl tracking-tight text-white mb-1">
          {t("login.restricted")}
        </h1>
        <p className="text-center text-sm text-white/40 mb-8">
          {t("login.subtitle")}
        </p>

        {error && (
          <div
            data-testid="login-error"
            className="mb-6 border border-destructive/50 bg-destructive/10 text-red-300 px-4 py-3 text-xs text-center"
          >
            {error}
          </div>
        )}

        <button
          data-testid="google-login-button"
          onClick={handleLogin}
          className="w-full bg-white text-[#0A0A0A] font-semibold uppercase tracking-wide text-sm py-3 flex items-center justify-center gap-3 hover:bg-[#0052FF] hover:text-white transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0A0A0A]"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          {t("login.continueGoogle")}
        </button>
      </div>
    </div>
  );
}
